import React from "react";
import Headercomponent from "./Headercomponent";

const AboutUs = () => {
  return (
    <div style={styles.pageContainer}>
      <Headercomponent />
      <div style={styles.contentContainer}>
        <div style={styles.card}>
          <h1 style={styles.heading}>About Us</h1>
          <p style={styles.text}>
            Welcome to our pharmacy platform, where your health and well-being
            are our top priorities. Our mission is to provide accessible,
            professional, and reliable pharmaceutical care to all our customers.
            We strive to ensure that everyone has access to the medications and
            health resources they need to live a healthy and fulfilling life.
          </p>
          <p style={styles.text}>
            We are committed to helping you manage your health by offering expert
            advice, high-quality medications, and personalized services. Our team
            of qualified pharmacists is always available to answer your questions
            and guide you in making informed decisions about your health. Whether
            you need assistance with prescriptions, over-the-counter medications,
            or general health advice, we are here to support you every step of
            the way.
          </p>
          <p style={styles.text}>
            Thank you for choosing us as your trusted health partner. Together,
            we can achieve a healthier and happier future. Your well-being is our
            passion, and we are dedicated to providing the highest standard of
            care to help you live your best life.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Roboto', sans-serif",
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    flexGrow: 1,
  },
  card: {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    maxWidth: "800px",
    width: "100%",
    textAlign: "left", // Heading remains left-aligned
  },
  heading: {
    fontSize: "36px",
    fontWeight: "700",
    color: "#2c3e50",
    marginBottom: "20px",
    textAlign: "center", // Center the heading
  },
  text: {
    fontSize: "18px",
    color: "#555",
    lineHeight: "1.8",
    marginBottom: "20px",
    textAlign: "justify", // Justify the text
  },
};

export default AboutUs;